/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { recallDiscount } from "../graphql";
import { VApplication } from "../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};


export interface IDiscountRecallMethods extends IPluginMethodMap {
  discountRecall(args: any): Promise<any>;
}

export class discountRecallService implements IAgentPlugin {
  readonly methods: IDiscountRecallMethods;

  constructor() {
    this.methods = {
      discountRecall: this.discountRecall.bind(this),
    };
  }

  async discountRecall(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(args)
    let filter = {
      input: {
        committeeId: args?.committee,
        count: args?.count,
        discountId: args?.discount
      }
    }
    try {
      if (client) {
        const res1 = await client.mutate({
          mutation: recallDiscount,
          variables: filter,
          fetchPolicy: "no-cache",
        });

        return {
          ...res1?.data?.recallDiscountsFromCommittee,
        };
      }

    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      console.log(
        `_display_message?.extensions?.display_message`,
        _display_message?.extensions?.display_message
      );
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private createInviteObjects(data: any) {
    let {
      presentation,
      type,
      sections,
      userEmail,
      maxInvites,
      sectionOptType,
      partition,
      inviteType,
    } = data;
    const inviteObjects: any[] = [];
    userEmail.forEach((email: any) => {
      if (email === "openreg@gem.com") {
        inviteType = "Open";
      }
      const inviteObj = {
        email,
        presentation,
        partition,
        sections: sections ? sections : null,
        inviteType: inviteType ?? "Closed",
        maxInvites: parseInt(maxInvites, 10) || 0,
        sectionOptType,
        openRegEnabled: inviteType === "Open" ? true : false,
      };
      inviteObjects.push(inviteObj);
    });
    console.log("inviteObjects", inviteObjects);
    return inviteObjects;
  }

  private validateArgs(args: any): any {
    let message = {
      isValidate: false,
      errorMessage: "",
    };
    const {
      presentation,
      type,
      sections,
      userEmail,
      maxInvites,
      sectionOptType,
      partition,
      inviteType,
    } = args;

    if (maxInvites === "" || maxInvites === null || maxInvites === undefined) {
      message = {
        ...message,
        isValidate: true,
        errorMessage: "Invites Count cannot be Empty",
      };
      return message;
    }

    if (maxInvites && maxInvites) {
      const count = parseInt(maxInvites, 10) || 0;
      if (count < 0) {
        message = {
          ...message,
          isValidate: true,
          errorMessage: "Invites Count cannot be negative",
        };
        return message;
      }
    }

    if (
      presentation === "" ||
      presentation === null ||
      presentation === undefined
    ) {
      message = {
        ...message,
        isValidate: true,
        errorMessage: "Presentation cannot be Empty",
      };
      return message;
    }
    if (
      partition === "" ||
      partition === null ||
      partition === undefined ||
      partition === "-"
    ) {
      message = {
        ...message,
        isValidate: true,
        errorMessage: "Partition cannot be Empty",
      };
      return message;
    }
    if (
      sectionOptType === "" ||
      sectionOptType === null ||
      sectionOptType === undefined ||
      sectionOptType === "-"
    ) {
      message = {
        ...message,
        isValidate: true,
        errorMessage: "Section Option Type cannot be Empty",
      };
      return message;
    }
    if (partition === "Default" || partition === "SpecialReserve") {
      if (sections !== null && sections !== undefined) {
        message = {
          ...message,
          isValidate: true,
          errorMessage: `Section should be null for partition type ${partition}`,
        };
        return message;
      }
    }
    if (partition === "SectionSpecific") {
      if (
        sections === null ||
        sections === "" ||
        sections === "-" ||
        sections === undefined
      ) {
        message = {
          ...message,
          isValidate: true,
          errorMessage: `Section Id Should be not empty`,
        };
      }
    }
    return message;
  }
}
